<template>
  <div>
    <template v-if="didUserJustLoginOrSignup">
      <b-headline type="h1" typography="h2" class="mb-6 l:mb-8" v-html="$t('headlineUserJustLoginOrSignup')" />
      <div v-html="userJustLoginOrSignup" class="text-base l:text-xl mb-8" />
    </template>
    <template v-else>
      <b-headline type="h1" typography="h15" class="mb-8" v-html="formattedHeadline" />
      <p class="mb-8 text-base l:text-xl">
        {{ $t("main", { sanitizedInviterName }) }}
      </p>
    </template>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import globals from "@/utils/globals"
import sanitizeHtml from "sanitize-html"

export default {
  name: "CopySection",
  totalBooks: globals.totalBooks,
  components: {
    BHeadline
  },
  props: {
    isUserLoggedIn: {
      default: false,
      type: Boolean
    },
    didUserJustLoginOrSignup: {
      default: false,
      type: Boolean
    },
    inviterName: {
      type: String,
      default: ""
    }
  },
  computed: {
    sanitizedInviterName() {
      return sanitizeHtml(this.inviterName, { allowedTags: [], allowedAttributes: {} })
    },
    formattedHeadline() {
      return this.$t("headline", {
        sanitizedInviterName: this.sanitizedInviterName
      })
    },
    userJustLoginOrSignup() {
      return this.$t("userJustLoginOrSignup", {
        sanitizedInviterName: this.sanitizedInviterName
      })
    }
  },
  i18n: {
    messages: {
      en: {
        headlineUserJustLoginOrSignup: "Almost there! Enter your name to accept your invite and get started",
        userJustLoginOrSignup:
          "Keep things personal by entering your name, then join {sanitizedInviterName}'s Blinkist Premium subscription!",
        headline: "{sanitizedInviterName} has invited you to join their Blinkist Premium plan!",
        main: "Join {sanitizedInviterName} on their Blinkist Premium plan, with a separate account of your own—at no extra cost."
      },
      de: {
        headlineUserJustLoginOrSignup: "Gleich geht’s los! <br/> Gib deinen Namen ein, um deine Einladung anzunehmen",
        userJustLoginOrSignup:
          "So wird’s persönlicher: Gib deinen Namen ein und tritt dem Premium-Abo von {sanitizedInviterName} bei.",
        headline: "{sanitizedInviterName} hat dich eingeladen, kostenlos ein Premium-Abo zu teilen",
        main: "Möchtest du dem Premium-Abo von {sanitizedInviterName} beitreten? Du erhältst deinen eigenen Account – ohne zusätzliche Kosten!"
      }
    }
  }
}
</script>
